import {Pipe, PipeTransform} from '@angular/core';
import {Match} from '../model/events/Match';

interface SplitName
{
  name: string;
  prename: string;
}

@Pipe({standalone: true, name: 'participantShortPipe'})
export class ParticipantShortPipe implements PipeTransform
{
  transform(participant: any, matchList: Match[]): string
  {
    if (!participant)
    {
      return '';
    }

    const splitName = this.splitName(participant);
    if (splitName)
      return this.getUniqueName(participant, matchList, splitName, 0);
    return '';
  }

  private getUniqueName(participant: any, matchList: Match[], splitName: any, prenameCount: number): string
  {
    let displayName = splitName.name.substring(0, 3).toUpperCase();
    if (prenameCount > 0)
    {
      displayName = displayName + ', ' + splitName.prename.substring(0, prenameCount).toUpperCase();
      if (prenameCount >= splitName.prename.length)
        return displayName; // kompletter Name erreicht
    }

    // console.log('compare: ' + displayName);

    for (const match of matchList)
    {
      if (match.writer)
      {
        if (match.writer.id === participant.id)
          continue;

        const sn = this.splitName(match.writer);
        if (sn)
        {
          let tempDisplayName = sn.name.substring(0, 3).toUpperCase();
          if (prenameCount > 0 && sn.prename)
            tempDisplayName = tempDisplayName + ', ' + sn.prename.substring(0, prenameCount).toUpperCase();

          if (tempDisplayName === displayName)
            return this.getUniqueName(participant, matchList, splitName, prenameCount + 1);
        }
      }
    }
    return displayName;
  }

  private splitName(participant: any): SplitName
  {
    // console.log('splitName', participant);
    if (participant && participant.displayName)
    {
      if (participant.displayName.includes(', '))
      {
        const splitted = participant.displayName.split(', ');
        if (splitted && splitted.length > 1)
        {
          const nachname = splitted[0];
          const vorname = splitted[1];
          return { name: nachname, prename: vorname};
        }
      }
      if (participant.displayName.includes(' '))
      {
        const splitted = participant.displayName.split(' ');
        if (splitted && splitted.length > 1)
        {
          const vorname = splitted[0];
          const nachname = splitted[1];
          return { name: nachname, prename: vorname};
        }
      }

      if (participant.displayName.includes(' & '))  // Doppel
      {
        const splitted = participant.displayName.split(' & ');
        if (splitted && splitted.length === 2)
        {
          const name1 = splitted[0];
          const name2 = splitted[1];

          const s = this.splitTextPoint(name1);
          if (s)
            return s;
          const s2 = this.splitTextComma(name2);
          if (s2)
            return s2;
        }
      }
    }
    if (participant.displayName)
      return { name: participant.displayName, prename: ''};

    return undefined;
  }

  private splitTextPoint(text: string): any
  {
    const splitted = text.split('. ');
    if (splitted && splitted.length > 1)
    {
      const vorname = splitted[0];
      const nachname = splitted[1];
      return { name: nachname, prename: vorname};
    }
  }
  private splitTextComma(text: string): any
  {
    const splitted = text.split(', ');
    if (splitted && splitted.length > 1)
    {
      const nachname = splitted[0];
      const vorname = splitted[1];
      return { name: nachname, prename: vorname};
    }
  }
}
